import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";

export default function PerformanceMarketing_ny() {
  return (
    <div className="Performance-Marketing pt-[160px] sm:pt-0">
      <Helmet>
        <title> Performance Marketing Agency in New York | Mean3</title>
        <meta
        name="description"
        content=" Looking for performance marketing companies in New York State? Mean3 delivers measurable ROI through paid search, social ads, and data-driven growth strategies. Schedule your free consultation today."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
    </div>
  );
}
